import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import styled from "@emotion/styled";
import { Button, Form, FormInstance, Input } from "antd";
import React, { Fragment } from "react";
import VariationOptionForm from "./VariationOptionForm";

interface ProductManyPriceChoiceProps {
  form: FormInstance;
  skuItems: VariationData[];
  variants: VariantsInput;
  is_guid: boolean;
  is_inventory: boolean;
}

const VariationOptionCard: React.FC<ProductManyPriceChoiceProps> = ({
  form,
  skuItems,
  variants,
  is_guid,
  is_inventory,
}) => {


  return (
    <FormWrapper>
      <Form.List name="sku_items">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }, index) => (
              <Fragment key={key}>
                <WrapperForm>
                  <Form.Item
                    {...restField}
                    name={[name, "name"]}
                    rules={[
                      {
                        required: true,
                        message: "กรุณากรอกชื่อตัวเลือก",
                      },
                    ]}
                    label="ชื่อตัวเลือก"
                    className="form-varation-name"
                    style={{ width: 880 }}
                  >
                    <Input
                      style={{ marginLeft: 20 }}
                      placeholder="ชื่อตัวเลือก"
                      className="form-varation-name__input"
                      size="small"
                    />
                  </Form.Item>
                  <WrapperButton>
                    <DeleteOutlined
                      style={{ marginLeft: 0, fontSize: 16 }}
                      onClick={() => remove(name)}
                    />
                  </WrapperButton>
                </WrapperForm>
                <VariationOpteionFormWrapper>
                  <VariationOptionForm
                    name={name}
                    form={form}
                    skuItem={skuItems[name]?.items}
                    variants={variants}
                    is_guid={is_guid}
                    is_inventory={is_inventory}
                  />
                </VariationOpteionFormWrapper>
              </Fragment>
            ))}
            <ButtonWrapper>
              <Form.Item>
                <Button
                // สร้างแค่ 1 ตัวเลือก
                  disabled={fields.length >= 1}
                  type="dashed"
                  block
                  icon={<PlusOutlined />}
                  style={{
                    width: 300,
                  }}
                  onClick={() => add()}
                >
                  เพิ่ม
                </Button>
              </Form.Item>
            </ButtonWrapper>
          </>
        )}
      </Form.List>
    </FormWrapper>
  );
};

export default VariationOptionCard;

const VariationOpteionFormWrapper = styled.div`
  margin-left: 30px;
  
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 10px;
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const WrapperForm = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;


const WrapperButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: -20px;
`;
